import { LIMIT } from '@/constants';
import { fetcher } from '@/services/graphql/fetcher/index';
import { Sort, type AnyObj } from '@/types';
import {
  fetchCompActivityDocument,
  fetchCompRecordsDetailDocument,
  fetchCompRecordsDocument,
} from '../graphql/docs';

/**
 * 获取礼品列表
 * @param skip - 数据略过个数
 */
export const fetchGiftList = async (skip: number, filterState: AnyObj) => {
  const res = await fetcher.query(fetchCompRecordsDocument, {
    variables: {
      options: {
        take: LIMIT,
        skip: LIMIT * skip,
        filter: {
          state: filterState,
        },
        sort: {
          createdAt: Sort.DESC,
        },
      },
    },
  });
  const data = res.data.value.compRecords.items;
  if (data) return data;
};

/**
 * 获取礼品详情
 * @param id - 礼品id
 */
export const fetchGiftDetails = async (id: string) => {
  const res = await fetcher.query(fetchCompRecordsDetailDocument, {
    variables: {
      compRecordId: id,
    },
  });
  const data = res.data.value?.compRecord;
  if (data) return data;
};

/**
 * 礼品配置信息
 */
export const fetchGiftActivity = async () => {
  const res = await fetcher.query(fetchCompActivityDocument, {});
  return res.data.value?.compActivity;
};
